import React from "react";

import { useParams } from "react-router-dom";

import FilePreviewPage from "@app/component/FilePreviewPage";

interface Props {}

const Files: React.FC<Props> = () => {
  const { fileId } = useParams<{ fileId: string }>();
  return <FilePreviewPage fileId={parseInt(fileId, 10)} />;
};

export default Files;
